/* eslint-disable import/no-anonymous-default-export */
export default {
  color: "text",
  variants: {
    logo: {
      color: "primary.500",
      fontSize: "84px",
    },
  },
};
